import LandingHero from '../features/outlets/components/LandingHero'
import OutletSearchCard from '../features/outlets/components/searchOutlets/OutletSearchCard'
import Page from '../features/layout/components/Page'

function HomePage() {
  console.log('HomePage component rendered')
  console.log('process.env.ENV', process.env.ENV)
  console.log('process.env.NODE_ENV', process.env.NODE_ENV)
  console.log(
    'process.env.INTERNAL_',
    process.env.INTERNAL_CORE_API_URL,
    process.env.INTERNAL_MEDIA_API_URL,
  )

  return (
    <Page>
      <LandingHero>
        <OutletSearchCard />
      </LandingHero>
    </Page>
  )
}

export default HomePage
